<template>
    <div class="pop-wrap" v-if="spa">
      <div class="pop-title">
        <div class="img-wrap">
          <img v-if="spa.gender == 2" :src="spa.avatar | avatar('women')" v-img-error-user="2" alt="" />
          <img v-else :src="spa.avatar | avatar('men')" v-img-error-user="1" alt="" />
        </div>
        <h2>{{spa.userName}}</h2>
      </div>
      <ul class="pop-list">
        <li v-if="spa.directNo"><span class="label">联系电话</span><a class="green" :href="'tel:' + spa.directNo">{{spa.directNo}}<span class="fr">呼叫</span></a></li>
        <li v-if="spa.mobilePhone && !spa.directNo"><span class="label">联系电话</span><a class="green" :href="'tel:' + spa.mobilePhone">{{spa.mobilePhone}}<span class="fr">呼叫</span></a></li>
        <li v-if="spa.email"><span class="label">联系邮箱</span><a class="green" :href="'mailto:'+spa.email">{{spa.email}}</a></li>
        <li v-if="spa.qq"><span class="label">联系QQ</span><a class="green" :href="'http://wpa.qq.com/msgrd?v=3&uin='+spa.qq+'&site=qq&menu=yes'" target="_blank">{{spa.qq}}</a></li>
      </ul>
      <div class="space"></div>
      <div class="close" @click="cancel">取消</div>
    </div>
</template>

<script>
export default {
  name: "SPA",
  props: {
    spa:{}
  },
  data() {
    return {
    }
  },
  watch:{
  },
  methods: {
    cancel(){
      this.$emit('close');
    }
  },
  created() {
  }
};
</script>